import { DashboardIcon,Admin,SettingSvg,FaqSvg,Home,Staging} from "./Sidebarsvg";

export const MenuItems = [
    {
      title: "Surveys",
      path: "/survey-category",
      roles: ["admin", "user", "manager"],
      icon: <DashboardIcon />,
      subMenu: [],
    },
    {
      title: "Home",
      path: "/home",
      roles: ["admin", "user", "manager"],
      icon: <Home />,
      subMenu: [],
    },
    {
      title: "Stage Mapping",
      path: "/stage-mapping",
      roles: ["admin", "user", "manager"],
      icon: <Staging />,
      subMenu: [],
    },
    {
      title: "Users",
      path: "/users",
      roles: ["admin", "user", "manager"],
      icon: <Admin />,
      subMenu: [],
    },
    {
      title: "FAQ's Categories",
      path: "/faq-categories",
      roles: ["admin", "user", "manager"],
      icon: <FaqSvg />,
      subMenu: [],
    },
    {
      title: "Quote App",
      path: "/user-tracking",
      roles: ["admin", "user", "manager"],
      icon: <FaqSvg />,
      subMenu: [],
    },
    {
      title: "Settings",
      path: "/settings",
      roles: ["admin", "user", "manager"],
      icon: <SettingSvg />,
      subMenu: [],
    },
    
   
  ];